import { render, staticRenderFns } from "./CountBadge.vue?vue&type=template&id=3f303c8a&scoped=true"
import script from "./CountBadge.vue?vue&type=script&lang=js"
export * from "./CountBadge.vue?vue&type=script&lang=js"
import style0 from "./CountBadge.vue?vue&type=style&index=0&id=3f303c8a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f303c8a",
  null
  
)

export default component.exports